import { render, staticRenderFns } from "./Liquid.vue?vue&type=template&id=45fabc72&scoped=true&"
import script from "./Liquid.vue?vue&type=script&lang=js&"
export * from "./Liquid.vue?vue&type=script&lang=js&"
import style0 from "./Liquid.vue?vue&type=style&index=0&id=45fabc72&prod&lang=scss&scoped=true&"
import style1 from "./Liquid.vue?vue&type=style&index=1&id=45fabc72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fabc72",
  null
  
)

export default component.exports